module.exports = __webpack_public_path__ + "img/logo-drogaria-sp.a04163f7.png";